/**
 * Mock Contractor Data
 *
 * Sample contractor data for development and testing
 */

import type { ContractorCardProps } from '../../ui/ContractorCard';

export const MOCK_CONTRACTORS: ContractorCardProps[] = [
  {
    id: '1',
    userId: 'user-1',
    name: 'John Smith',
    avatarUrl: 'https://i.pravatar.cc/150?img=1',
    rating: 4.8,
    hourlyRate: 75,
    city: 'Toronto',
    province: 'ON',
    completedOrders: 156,
    isVerified: true,
    categories: [
      { id: 'cat-1', nameEn: 'Plumbing', nameFr: 'Plomberie' }
    ],
  },
  {
    id: '2',
    userId: 'user-2',
    name: 'Maria Garcia',
    avatarUrl: 'https://i.pravatar.cc/150?img=25',
    rating: 4.9,
    hourlyRate: 85,
    city: 'Mississauga',
    province: 'ON',
    completedOrders: 245,
    isVerified: true,
    categories: [
      { id: 'cat-2', nameEn: 'Electrical', nameFr: 'Électrique' }
    ],
  },
  {
    id: '3',
    userId: 'user-3',
    name: 'David Chen',
    avatarUrl: 'https://i.pravatar.cc/150?img=8',
    rating: 4.7,
    hourlyRate: 65,
    city: 'Brampton',
    province: 'ON',
    completedOrders: 98,
    isVerified: false,
    categories: [
      { id: 'cat-3', nameEn: 'Carpentry', nameFr: 'Menuiserie' }
    ],
  },
  {
    id: '4',
    userId: 'user-4',
    name: 'Sarah Johnson',
    avatarUrl: 'https://i.pravatar.cc/150?img=32',
    rating: 5.0,
    hourlyRate: 95,
    city: 'Toronto',
    province: 'ON',
    completedOrders: 189,
    isVerified: true,
    categories: [
      { id: 'cat-4', nameEn: 'Interior Design', nameFr: 'Design Intérieur' }
    ],
  },
  {
    id: '5',
    userId: 'user-5',
    name: 'Michael Brown',
    avatarUrl: 'https://i.pravatar.cc/150?img=13',
    rating: 4.6,
    hourlyRate: 70,
    city: 'Oakville',
    province: 'ON',
    completedOrders: 112,
    isVerified: true,
    categories: [
      { id: 'cat-5', nameEn: 'Landscaping', nameFr: 'Aménagement Paysager' }
    ],
  },
  {
    id: '6',
    userId: 'user-6',
    name: 'Emily Wilson',
    avatarUrl: 'https://i.pravatar.cc/150?img=44',
    rating: 4.9,
    hourlyRate: 80,
    city: 'Toronto',
    province: 'ON',
    completedOrders: 267,
    isVerified: true,
    categories: [
      { id: 'cat-6', nameEn: 'Cleaning', nameFr: 'Nettoyage' }
    ],
  },
  {
    id: '7',
    userId: 'user-7',
    name: 'Robert Anderson',
    avatarUrl: 'https://i.pravatar.cc/150?img=12',
    rating: 4.8,
    hourlyRate: 90,
    city: 'Vaughan',
    province: 'ON',
    completedOrders: 178,
    isVerified: true,
    categories: [
      { id: 'cat-7', nameEn: 'Roofing', nameFr: 'Toiture' }
    ],
  },
  {
    id: '8',
    userId: 'user-8',
    name: 'Jessica Martinez',
    avatarUrl: 'https://i.pravatar.cc/150?img=45',
    rating: 4.7,
    hourlyRate: 72,
    city: 'Toronto',
    province: 'ON',
    completedOrders: 134,
    isVerified: false,
    categories: [
      { id: 'cat-8', nameEn: 'Pet Care', nameFr: 'Soins aux Animaux' }
    ],
  },
  {
    id: '9',
    userId: 'user-9',
    name: 'Thomas Lee',
    avatarUrl: 'https://i.pravatar.cc/150?img=33',
    rating: 4.9,
    hourlyRate: 100,
    city: 'Richmond Hill',
    province: 'ON',
    completedOrders: 289,
    isVerified: true,
    categories: [
      { id: 'cat-9', nameEn: 'Appliance Repair', nameFr: 'Réparation d\'Appareils' }
    ],
  },
  {
    id: '10',
    userId: 'user-10',
    name: 'Amanda Taylor',
    avatarUrl: 'https://i.pravatar.cc/150?img=28',
    rating: 5.0,
    hourlyRate: 88,
    city: 'Markham',
    province: 'ON',
    completedOrders: 201,
    isVerified: true,
    categories: [
      { id: 'cat-10', nameEn: 'Event Planning', nameFr: 'Planification d\'Evénements' }
    ],
  },
  {
    id: '11',
    userId: 'user-11',
    name: 'Christopher White',
    avatarUrl: 'https://i.pravatar.cc/150?img=52',
    rating: 4.6,
    hourlyRate: 78,
    city: 'Burlington',
    province: 'ON',
    completedOrders: 89,
    isVerified: false,
    categories: [
      { id: 'cat-11', nameEn: 'Pool Maintenance', nameFr: 'Entretien de Piscine' }
    ],
  },
  {
    id: '12',
    userId: 'user-12',
    name: 'Lisa Thompson',
    avatarUrl: 'https://i.pravatar.cc/150?img=47',
    rating: 4.8,
    hourlyRate: 85,
    city: 'Toronto',
    province: 'ON',
    completedOrders: 156,
    isVerified: true,
    categories: [
      { id: 'cat-12', nameEn: 'Tutoring', nameFr: 'Tutorat' }
    ],
  },
  {
    id: '13',
    userId: 'user-13',
    name: 'Daniel Rodriguez',
    avatarUrl: 'https://i.pravatar.cc/150?img=59',
    rating: 4.9,
    hourlyRate: 92,
    city: 'Mississauga',
    province: 'ON',
    completedOrders: 223,
    isVerified: true,
    categories: [
      { id: 'cat-13', nameEn: 'Auto Repair', nameFr: 'Réparation Automobile' }
    ],
  },
  {
    id: '14',
    userId: 'user-14',
    name: 'Sophia Kim',
    avatarUrl: 'https://i.pravatar.cc/150?img=41',
    rating: 4.7,
    hourlyRate: 75,
    city: 'Toronto',
    province: 'ON',
    completedOrders: 145,
    isVerified: true,
    categories: [
      { id: 'cat-14', nameEn: 'Personal Training', nameFr: 'Entraînement Personnel' }
    ],
  },
  {
    id: '15',
    userId: 'user-15',
    name: 'Kevin Patel',
    avatarUrl: 'https://i.pravatar.cc/150?img=15',
    rating: 4.8,
    hourlyRate: 95,
    city: 'Brampton',
    province: 'ON',
    completedOrders: 198,
    isVerified: false,
    categories: [
      { id: 'cat-15', nameEn: 'Computer Repair', nameFr: 'Réparation d\'Ordinateur' }
    ],
  },
  {
    id: '16',
    userId: 'user-16',
    name: 'Rachel Green',
    avatarUrl: 'https://i.pravatar.cc/150?img=38',
    rating: 5.0,
    hourlyRate: 105,
    city: 'Toronto',
    province: 'ON',
    completedOrders: 276,
    isVerified: true,
    categories: [
      { id: 'cat-16', nameEn: 'Photography', nameFr: 'Photographie' }
    ],
  },
];
